import { useState } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { api } from '../lib/api'
import { setToken } from '../lib/auth'
import Button from '../components/ui/Button'
import Input from '../components/ui/Input'

export default function Register() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [err, setErr] = useState('')
  const [busy, setBusy] = useState(false)
  const navigate = useNavigate()

  async function submit(e: React.FormEvent) {
    e.preventDefault()
    setErr('')
    setBusy(true)
    try {
      const res = await api<{ token: string }>('/api/auth/register', {
        method: 'POST',
        body: JSON.stringify({ email, password }),
      })
      setToken(res.token)
      navigate('/dashboard')
    } catch (e) {
      setErr((e as Error).message || 'Hata')
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-2 mb-6">
            <span className="w-8 h-8 rounded-md bg-gradient-to-br from-[var(--color-accent)] to-[#8a93f0] flex items-center justify-center text-white text-base font-bold">
              P
            </span>
            <span className="text-xl font-semibold tracking-tight">pixelkit</span>
          </div>
          <h1 className="text-2xl font-semibold mb-1">Hesap oluştur</h1>
          <p className="text-sm text-[var(--color-text-muted)]">Email ile başla — sonra Kick'i bağlarsın</p>
        </div>

        <div className="rounded-lg border border-[var(--color-border)] bg-[var(--color-surface)] p-6">
          <form onSubmit={submit} className="space-y-3">
            <div>
              <label className="block text-xs font-medium mb-1.5 text-[var(--color-text-muted)]">Email</label>
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="ornek@email.com"
                required
                autoFocus
              />
            </div>
            <div>
              <label className="block text-xs font-medium mb-1.5 text-[var(--color-text-muted)]">Şifre</label>
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="En az 8 karakter"
                minLength={8}
                required
              />
            </div>
            {err && (
              <div className="text-xs px-3 py-2 rounded bg-[var(--color-danger)]/10 text-[var(--color-danger)] border border-[var(--color-danger)]/30">
                {err}
              </div>
            )}
            <Button type="submit" variant="primary" size="lg" className="w-full" disabled={busy}>
              {busy ? 'Oluşturuluyor…' : 'Hesap oluştur'}
            </Button>
          </form>
        </div>

        <div className="text-center text-sm text-[var(--color-text-muted)] mt-6">
          Hesabın var mı?{' '}
          <Link to="/login" className="text-[var(--color-accent-hover)] hover:underline">
            Giriş yap
          </Link>
        </div>
      </div>
    </div>
  )
}
